import(/* webpackMode: "eager" */ "/opt/build/repo/app/booking/page.tsx");
